import { useLayoutEffect, useRef, useState } from 'react'

export interface PillBox {
  left: number
  top: number
  width: number
  height: number
}

const BUTTON_GROUP_ITEMS = '[data-baseweb="button-group"] > button'

const useSlidingPill = (enabled: boolean, selectedIndex: number | undefined, itemSelector = BUTTON_GROUP_ITEMS) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [box, setBox] = useState<PillBox | null>(null)
  const [animated, setAnimated] = useState(false)

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current
    const button =
      selectedIndex === undefined ? undefined : wrapper?.querySelectorAll<HTMLElement>(itemSelector)[selectedIndex]
    if (!enabled || !wrapper || !button) {
      setBox(null)
      return undefined
    }

    const measure = () => {
      const wrapperRect = wrapper.getBoundingClientRect()
      const buttonRect = button.getBoundingClientRect()
      setBox({
        left: buttonRect.left - wrapperRect.left,
        top: buttonRect.top - wrapperRect.top,
        width: buttonRect.width,
        height: buttonRect.height,
      })
    }
    measure()

    if (typeof ResizeObserver === 'undefined') return undefined
    const observer = new ResizeObserver(measure)
    observer.observe(wrapper)
    return () => observer.disconnect()
  }, [enabled, selectedIndex, itemSelector])

  useLayoutEffect(() => {
    if (!box || animated) return undefined
    const frame = requestAnimationFrame(() => setAnimated(true))
    return () => cancelAnimationFrame(frame)
  }, [box, animated])

  return { wrapperRef, box, animated }
}

export default useSlidingPill
